import { SvgIcon } from '@mui/material';
import { FC } from 'react';

import { IconProps } from './types';

export const UpIcon: FC<IconProps> = ({ width = 10, height = 10 }) => {
  return (
    <SvgIcon width={width} height={height} viewBox={[0, 0, width, height].join(' ')} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 9V1" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M1 5L5 1L9 5" strokeLinecap="round" strokeLinejoin="round"/>
    </SvgIcon>

  );
};
